export type KernelType = "rbf" | "linear";
export type DatasetName = "webtender" | "communities" | "optdigits" | "movies";

export const DATASETS: { id: DatasetName; label: string }[] = [
  { id: "webtender", label: "Webtender" },
  { id: "communities", label: "Communities" },
  { id: "optdigits", label: "Opt. Digits" },
  { id: "movies", label: "Movies" },
];

export interface InVisData {
  dataset: DatasetName;
  kernel: KernelType;
  n: number;
  nLandmarks: number;
  names: string[];
  labels: number[];
  S: number[][];          // n x nLandmarks
  C_var: number[][];      // nLandmarks x nLandmarks
  initialEmbedding: number[][]; // n x 2
  initialV1: number[];    // nLandmarks
  initialV2: number[];    // nLandmarks
}

export interface ControlPoint {
  index: number;
  targetX: number;
  targetY: number;
}

export interface ViewTransform {
  offsetX: number;
  offsetY: number;
  scale: number;
}
